import { QuestionRequiredPrepMilli } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { useReservationRequiredPrepMillisecond } from "./hooks/use-required-prep-milli";

export const QuestionReservationRequiredPrepMilli = () => {
	const {
		isEdited,
		hasError,
		requiredPrepMillisecondBeforeDate,
		onSetRequiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeDateOptions,
		requiredPrepMillisecondBeforeHour,
		requiredPrepMillisecondBeforeHourOptions,
		onSetRequiredPrepMillisecondBeforeHour,
	} = useReservationRequiredPrepMillisecond();

	return (
		<QuestionRequiredPrepMilli
			requiredPrepMillisecondBeforeDate={requiredPrepMillisecondBeforeDate}
			onSetRequiredPrepMillisecondBeforeDate={onSetRequiredPrepMillisecondBeforeDate}
			requiredPrepMillisecondBeforeDateOptions={requiredPrepMillisecondBeforeDateOptions}
			requiredPrepMillisecondBeforeHour={requiredPrepMillisecondBeforeHour}
			onSetRequiredPrepMillisecondBeforeHour={onSetRequiredPrepMillisecondBeforeHour}
			requiredPrepMillisecondBeforeHourOptions={requiredPrepMillisecondBeforeHourOptions}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
};

QuestionReservationRequiredPrepMilli.displayName = "QuestionReservationRequiredPrepMilli";
